<template>
    <div v-if="loading" class="skeleton" :class="classList" :style="style"></div>
</template>

<script>
    export default {
        name: 'SkeletonLoader',
        props: {
            loading: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: 'rect',
            },
            color: {
                type: String,
                default: 'light',
            },
            width: {
                type: String,
                default: '100%',
            },
            maxWidth: {
                type: String,
                default: 'none',
            },
            height: {
                type: String,
            },
            borderRadius: {
                type: String,
                default: '5px',
            },
        },
        computed: {
            classList() {
                return [this.type, this.color];
            },
            style() {
                return {
                    borderRadius: this.type === 'circle' ? '50%' : this.borderRadius,
                    width: this.width,
                    maxWidth: this.maxWidth,
                    height: this.height,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @function alpha($light) {
        @return if($light, 0.5, 0.3);
    }

    @mixin loader($light: true) {
        display: block;
        content: '';
        width: 100%;
        height: 100%;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(#fff, alpha($light)), rgba(255, 255, 255, 0));
        transform: translateX(-100%);
        animation: loading 1s infinite;
    }

    .skeleton {
        overflow: hidden;
        z-index: 1;
    }

    .light {
        background-color: var(--joy-color-neutral-20);
        &::after {
            @include loader(true);
        }
    }

    .dark {
        background-color: var(--joy-color-neutral-20);
        &::after {
            @include loader(false);
        }
    }

    /* Safari */
    @-webkit-keyframes loading {
        100% {
            -webkit-transform: translate(100%);
        }
    }

    @keyframes loading {
        100% {
            transform: translateX(100%);
        }
    }
</style>
